import React from 'react';
import Tour from 'reactour';
import { Button } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';

const StatisticsCurrenciesTour = ({ onFinishClick }) => {
  return (
    <Tour
      isOpen
      showButtons={false}
      showNavigation={false}
      showCloseButton={false}
      showNumber={false}
      className="tour statistics-tour"
      onRequestClose={onFinishClick}
      steps={[
        {
          selector: '.currencies',
          content: () => {
            return (
              <>
                <p>
                  <FMessage id="statistics.currencies-tour.text" />
                </p>
                <Button color="primary" size="sm" onClick={onFinishClick}>
                  <FMessage id="statistics.currencies-tour.button" />
                </Button>
              </>
            );
          },
          position: 'bottom',
        },
      ]}
    />
  );
};

export default StatisticsCurrenciesTour;
